import React, { useEffect, useState, useRef } from 'react';
import Modal from 'components/shared/Modal/Modal';
import { Status } from 'common/utils/constants';
import {
  HEATMAP_DIAG_RASTER_SCREEN_INDEXES
  // POLARIZATION_SELECTIONS,
  // SAMPLE_ERROR_STATUS_DATA
} from '../utils/constants';
import { useDispatch, useSelector } from 'react-redux';
import { doInitiateRaster, updateStatus } from 'redux/actions';
import HeatmapDiagRasterConfigScreen from '../HeatmapDiagRasterConfigScreen/HeatmapDiagRasterConfigScreen';
import HeatmapDiagRasterProgressScreen from '../HeatmapDiagRasterProgressScreen/HeatmapDiagRasterProgressScreen';
import HeatmapDiagRasterSuccessScreen from '../HeatmapDiagRasterSuccessScreen/HeatmapDiagRasterSuccessScreen';
import HeatmapDiagRasterErrorScreen from '../HeatmapDiagRasterErrorScreen/HeatmapDiagRasterErrorScreen';
import HeatmapDiagRasterWarningScreen from '../HeatmapDiagRasterWarningScreen/HeatmapDiagRasterWarningScreen';
import { getInitiateRasterStatus } from 'apis/InitiateRaster';
import { apiConfig } from 'config';
import './HeatmapDiagRasterModal.css';

let timeCount = 0;
let closeModalSeconds = 5;
// const DEFAULT_TIMEOUT_MINUTE = 5;
// const DEFAULT_MAX_RASTER_GAIN = 55;
// const DEFAULT_STEPS_DEGREE = { az: 2, el: 5 };
// const DEFAULT_MIN_MAX_RANGE = { az: { min: -75, max: 75 }, el: { min: -35, max: 35 } };

const HeatmapDiagRasterModal = (props) => {
  // const [timeoutMinute, setTimeoutMinute] = useState(DEFAULT_TIMEOUT_MINUTE);
  // const [maxRasterGain, setMaxRasterGain] = useState(DEFAULT_MAX_RASTER_GAIN);
  // const [stepsDegree, setStepsDegree] = useState(DEFAULT_STEPS_DEGREE);
  // const [minMaxRange, setMinMaxRange] = useState(DEFAULT_MIN_MAX_RANGE);
  // const [polarizationSelections, setPolarizationSelections] = useState(POLARIZATION_SELECTIONS);
  // const [activePolarization, setActivePolarization] = useState('vertical');
  const [selectedPolarization, setSelectedPolarization] = useState('vertical');
  const [screenIndex, setScreenIndex] = useState(HEATMAP_DIAG_RASTER_SCREEN_INDEXES.WARNING);
  const [errorCode, setErrorCode] = useState(null);
  const [isRetrieveBtnTriggered, setIsRetrieveBtnTriggered] = useState(false);
  const [verticalProgress, setVerticalProgress] = useState(0);
  const [horizontalProgress, setHorizontalProgress] = useState(0);
  const [customStatus, setCustomStatus] = useState(null);
  const [customMessage, setCustomMessage] = useState(null);
  const [localSettings, setLocalSettings] = useState([]);
  const [inputErrors, setInputErrors] = useState(null);
  const [getProgressErrorMsg, setGetProgressErrorMsg] = useState(null);
  const dispatch = useDispatch();

  const autoCloseModalInterval = useRef(null);
  const retrieveDiagRasterTimeout = useRef(null);
  const verticalProgressInterval = useRef(null);
  const horizontalProgressInterval = useRef(null);
  const retrieveDiagRasterTimeout2 = useRef(null);
  const progressRunner = useRef(null);
  const progressRunner2 = useRef(null);
  const abortController = useRef(null);
  const abortProgressController = useRef(null);
  const autoNextScreenTimeout = useRef(null);

  const initiateRasterStatusName = `POST-InitiateRaster-${props.donorDevice}`;
  const initiateRasterStatus = useSelector((store) => store.statuses[initiateRasterStatusName]);
  const isFetching = initiateRasterStatus === Status.PENDING;
  const isSucceeded = initiateRasterStatus === Status.SUCCESS;
  const isFailed = initiateRasterStatus === Status.FAILURE;

  const progressStatusName = `GET-InitiateRasterStatus-${props.donorDevice}`;
  const progressStatus = useSelector((store) => store.statuses[progressStatusName]);
  const isProgressFetching = progressStatus === Status.PENDING;
  const isProgressSucceeded = progressStatus === Status.SUCCESS;
  const isProgressFailed = progressStatus === Status.FAILURE;

  useEffect(() => {
    if (isFetching || isProgressFetching) {
      // retrieveDiagRasterTimeout2.current = setTimeout(() => {
      //   if (
      //     (!initiateRasterStatus || isFetching || isFailed || isProgressFailed) &&
      //     !isSucceeded &&
      //     !isProgressSucceeded
      //   ) {
      //     setScreenIndex(HEATMAP_DIAG_RASTER_SCREEN_INDEXES.ERROR);
      //     setErrorCode(408);
      //     clearTimeoutAndInterval();
      //   }
      // }, timeoutMinute * 1000 * 60);
    }
    if (progressStatus === Status.SUCCESS && screenIndex === HEATMAP_DIAG_RASTER_SCREEN_INDEXES.SUCCESS) {
      autoCloseModalInterval.current = setInterval(() => {
        timeCount++;
        console.log('closing modal in: ', closeModalSeconds - timeCount);

        if (timeCount === closeModalSeconds) {
          clearTimeoutAndInterval();
          timeCount = 0;
          onCloseScreen();
          props.setIsHeatmapViewAndExportModalOpen(true);
          props.fetchRasterRecordsForDevice();
        }
      }, 1000);
    }
  }, [
    initiateRasterStatus,
    screenIndex,
    // timeoutMinute,
    isRetrieveBtnTriggered,
    isFailed,
    isFetching,
    isProgressFailed,
    isProgressFetching,
    isSucceeded,
    isProgressSucceeded
  ]);

  const resetStates = () => {
    dispatch(updateStatus(initiateRasterStatusName, Status.NONE));
    dispatch(updateStatus(progressStatusName, Status.NONE));
    // setTimeoutMinute(DEFAULT_TIMEOUT_MINUTE);
    // setMaxRasterGain(DEFAULT_MAX_RASTER_GAIN);
    // setStepsDegree(DEFAULT_STEPS_DEGREE);
    // setMinMaxRange(DEFAULT_MIN_MAX_RANGE);
    // setPolarizationSelections(POLARIZATION_SELECTIONS);
    // setActivePolarization('vertical');
    setSelectedPolarization('vertical');
    setScreenIndex(HEATMAP_DIAG_RASTER_SCREEN_INDEXES.CONFIG);
    setErrorCode(null);
    setIsRetrieveBtnTriggered(false);
    setVerticalProgress(0);
    setHorizontalProgress(0);
    setCustomStatus(null);
    setGetProgressErrorMsg(null);
    clearTimeoutAndInterval();
  };

  const cancelRequest = () => abortController?.current && abortController.current.abort();
  const cancelStatusUriRequest = () => abortProgressController?.current && abortProgressController.current.abort();

  const clearTimeoutAndInterval = () => {
    timeCount = 0;
    retrieveDiagRasterTimeout?.current && clearTimeout(retrieveDiagRasterTimeout.current);
    verticalProgressInterval?.current && clearInterval(verticalProgressInterval.current);
    horizontalProgressInterval?.current && clearInterval(horizontalProgressInterval.current);
    retrieveDiagRasterTimeout2?.current && clearTimeout(retrieveDiagRasterTimeout2);
    autoCloseModalInterval?.current && clearInterval(autoCloseModalInterval.current);
    progressRunner?.current && clearInterval(progressRunner.current);
    progressRunner2?.current && clearInterval(progressRunner2.current);
    autoNextScreenTimeout?.current && clearTimeout(autoNextScreenTimeout.current);
  };

  const progressIntervalRunner = (ref, statusUri, polarization, ref2, statusUri2) => {
    return (
      statusUri &&
      setInterval(() => {
        getInitiateRasterStatus(statusUri, abortProgressController)
          .then(async (res) => {
            dispatch(updateStatus(progressStatusName, Status.SUCCESS));
            let polProgress = polarization === 'horizontal' ? horizontalProgress : verticalProgress;
            let currentProgress = res.customStatus?.status_info?.progress;
            // Debug with sample error status data
            // if (currentProgress === 5) {
            //   res = SAMPLE_ERROR_STATUS_DATA;
            // }
            if (currentProgress != null && currentProgress !== polProgress) {
              polarization === 'horizontal'
                ? setHorizontalProgress(currentProgress)
                : setVerticalProgress(currentProgress);

              if (currentProgress === 100) {
                clearInterval(ref.current);
              }
            }
            if (
              res &&
              (res.runtimeStatus === 'Completed' ||
                res.runtimeStatus === 'Terminated' ||
                res.runtimeStatus === 'Failed')
            ) {
              if (res.runtimeStatus === 'Failed' || res?.customStatus?.status === 'error') {
                setGetProgressErrorMsg(res?.customStatus?.message);
                setScreenIndex(HEATMAP_DIAG_RASTER_SCREEN_INDEXES.ERROR);
              }
              clearInterval(ref.current);
              if (ref2 && statusUri2 && res.runtimeStatus === 'Completed' && currentProgress === 100) {
                ref2.current = progressIntervalRunner(ref2, statusUri2, 'horizontal');
              } else {
                res.runtimeStatus === 'Completed' &&
                  !(res.runtimeStatus === 'Failed' || res?.customStatus?.status === 'error') &&
                  setScreenIndex(HEATMAP_DIAG_RASTER_SCREEN_INDEXES.SUCCESS);
              }
            } else {
              if (res.customStatus) {
                if (customStatus !== res.customStatus.status) {
                  setCustomStatus(res.customStatus.status);
                }
                if (res.customStatus.message) {
                  setCustomMessage(res.customStatus.message);
                }
              }

              if (res.customStatus && res.customStatus.status === 'completed') {
                // call getRasterInfo API
                clearInterval(ref.current);
                setCustomStatus(res.customStatus.status);
              }
            }
          })
          .catch((error) => {
            setGetProgressErrorMsg(error.message);
            dispatch(updateStatus(progressStatusName, Status.FAILURE));
            clearInterval(ref.current);
            setScreenIndex(HEATMAP_DIAG_RASTER_SCREEN_INDEXES.ERROR);
            console.log(error.message);
          });
      }, 4000)
    );
  };

  const retrieveDiagRasterAction = (fromErrorScreen = false) => {
    const configuration = {};

    for (let config of localSettings) {
      if (config.name === 'polarization') {
        configuration[config.name] = config.current?.toLowerCase() || config.default?.toLowerCase();
      } else {
        configuration[config.name] = config.current || config.default;
      }
    }

    setScreenIndex(HEATMAP_DIAG_RASTER_SCREEN_INDEXES.IN_PROGRESS);

    const init_raster_cb_success = (res) => {
      setErrorCode(null);
      setScreenIndex(HEATMAP_DIAG_RASTER_SCREEN_INDEXES.IN_PROGRESS);
      progressRunner.current = progressIntervalRunner(
        progressRunner,
        res.statusQueryGetUri,
        configuration.polarization
      );
    };

    const init_raster_both_cb_success = (res) => {
      const verticalRasterId = res.verticalRasterId;
      const horizontalRasterId = res.horizontalRasterId;
      const verticalRasterStatusUri = apiConfig.cmServiceStatusQueryGetUri(verticalRasterId);
      const horizontalRasterStatusUri = apiConfig.cmServiceStatusQueryGetUri(horizontalRasterId);
      setErrorCode(null);
      setScreenIndex(HEATMAP_DIAG_RASTER_SCREEN_INDEXES.IN_PROGRESS);
      progressRunner.current = progressIntervalRunner(
        progressRunner,
        verticalRasterStatusUri,
        'vertical',
        progressRunner2,
        horizontalRasterStatusUri
      );
    };

    let cb_failed = (errorCode) => {
      setErrorCode(errorCode);
      setScreenIndex(HEATMAP_DIAG_RASTER_SCREEN_INDEXES.ERROR);
    };
    abortController.current = new AbortController();

    const body = {
      source: 'diag',
      type: 'debug',
      configuration: configuration
    };

    dispatch(
      doInitiateRaster(
        props.donorDevice,
        body,
        configuration.polarization === 'both' ? init_raster_both_cb_success : init_raster_cb_success,
        cb_failed,
        abortController
      )
    );
  };

  const onCloseScreen = (fromErrorScreen = false) => {
    timeCount = 0;
    dispatch(updateStatus(initiateRasterStatusName, Status.NONE));
    clearTimeoutAndInterval();
    cancelRequest();
    cancelStatusUriRequest();
    if (screenIndex === HEATMAP_DIAG_RASTER_SCREEN_INDEXES.SUCCESS) {
      props.setIsHeatmapViewAndExportModalOpen(true);
      props.fetchRasterRecordsForDevice();
    }
    resetStates();
    !fromErrorScreen && props.onClose();
  };

  const modalHeight = screenIndex === HEATMAP_DIAG_RASTER_SCREEN_INDEXES.CONFIG ? 868 : 238;
  const modalWidth = screenIndex === HEATMAP_DIAG_RASTER_SCREEN_INDEXES.CONFIG ? 660 : 454;

  return (
    <Modal 
      animateX={false}
      close={onCloseScreen}
      noPadding
      height={modalHeight}
      width={modalWidth}
      closeXHidden={screenIndex === HEATMAP_DIAG_RASTER_SCREEN_INDEXES.IN_PROGRESS}
    >
      {screenIndex === HEATMAP_DIAG_RASTER_SCREEN_INDEXES.WARNING && (
        <HeatmapDiagRasterWarningScreen onClose={onCloseScreen} setScreenIndex={setScreenIndex} />
      )}
      {screenIndex === HEATMAP_DIAG_RASTER_SCREEN_INDEXES.CONFIG && (
        <HeatmapDiagRasterConfigScreen
          donorDevice={props.donorDevice}
          onClose={onCloseScreen}
          retrieveDiagRasterAction={retrieveDiagRasterAction}
          // timeoutMinute={timeoutMinute}
          // maxRasterGain={maxRasterGain}
          // stepsDegree={stepsDegree}
          // minMaxRange={minMaxRange}
          // polarizationSelections={polarizationSelections}
          // activePolarization={activePolarization}
          // setPolarizationSelections={setPolarizationSelections}
          // setActivePolarization={setActivePolarization}
          setSelectedPolarization={setSelectedPolarization}
          // setTimeoutMinute={setTimeoutMinute}
          // setMaxRasterGain={setMaxRasterGain}
          // setStepsDegree={setStepsDegree}
          // setMinMaxRange={setMinMaxRange}
          isFetching={isFetching}
          setLocalSettings={setLocalSettings}
          inputErrors={inputErrors}
          setInputErrors={setInputErrors}
        />
      )}
      {screenIndex === HEATMAP_DIAG_RASTER_SCREEN_INDEXES.IN_PROGRESS && (
        <HeatmapDiagRasterProgressScreen
          onClose={onCloseScreen}
          // timeoutMinute={timeoutMinute}
          donorDevice={props.donorDevice}
          verticalProgressInterval={verticalProgressInterval}
          horizontalProgressInterval={horizontalProgressInterval}
          // polarizationSelections={polarizationSelections}
          selectedPolarization={selectedPolarization}
          verticalProgress={verticalProgress}
          horizontalProgress={horizontalProgress}
          setVerticalProgress={setVerticalProgress}
          setHorizontalProgress={setHorizontalProgress}
          customStatusMessage={customMessage ? customMessage : 'Please wait. Loading...'}
        />
      )}
      {screenIndex === HEATMAP_DIAG_RASTER_SCREEN_INDEXES.SUCCESS && (
        <HeatmapDiagRasterSuccessScreen onClose={onCloseScreen} />
      )}
      {screenIndex === HEATMAP_DIAG_RASTER_SCREEN_INDEXES.ERROR && (
        <HeatmapDiagRasterErrorScreen
          onClose={(fromErrorScreen) => onCloseScreen(fromErrorScreen)}
          errorCode={errorCode}
          // retrieveDiagRasterAction={retrieveDiagRasterAction}
          cancelRequest={cancelRequest}
          cancelStatusUriRequest={cancelStatusUriRequest}
          initiateRasterStatusName={initiateRasterStatusName}
          progressStatusName={progressStatusName}
          clearTimeoutAndInterval={clearTimeoutAndInterval}
          resetStates={resetStates}
          setIsRetrieveBtnTriggered={setIsRetrieveBtnTriggered}
          getProgressErrorMsg={getProgressErrorMsg}
        />
      )}
    </Modal>
  );
};

export default React.memo(HeatmapDiagRasterModal);
